class InvoicesPaymentEditModalCtrl {

    constructor(invoice, payment, Invoice, SweetAlert, Error, $uibModalInstance, PaymentsService) {
        this.currentInvoice = invoice;
        this.model = payment;
        this.invoiceModel = Invoice;
        this.sweetAlert = SweetAlert;
        this.error = Error;
        this.modalInstance = $uibModalInstance;
        this.paymentsService = PaymentsService;
        this.allowTypeChange = false;

        this.enableDelete = true;
        this.types = [];
        this.states = [];
        this.loadTypes();
        this.loadStates();
    }

    loadTypes() {
        this.paymentsService.getAllTypes().then((types) => {
            this.types = types;
            if(this.model.type === null) {
                this.model.type = this.types[0].key;
            }
        });
    }

    loadStates() {
        this.paymentsService.getAllStates().then((states) => {
            console.log('done', states);
            this.states = states;
            if(this.model.status === null) {
                this.model.status = this.states[0].key;
            }
        }, (e) => {
            console.log(e);
        });
    }

    save() {
        this.invoiceModel.one(this.currentInvoice.id).customPUT(_.cloneDeep(this.model), 'payments/' + this.model.id).then(() => {
            this.sweetAlert.success('success', 'payment saved');
            this.close();
        });
    }

    deletePayment() {
        this.sweetAlert.swal({
                title: "Delete?",
                text: "Are you sure you want to delete this payment?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                closeOnConfirm: true
            },
            (isConfirmed) => {
                if (isConfirmed) {
                    this.invoiceModel.one(this.currentInvoice.id).customDELETE('payments/' + this.model.id).then(() => {
                        this.sweetAlert.info('Success', 'Payment has been deleted');
                        this.close();
                    }, (error) => {
                        this.error.default(error);
                        this.dismiss();
                    });
                }
            });
    }

    close() {
        this.modalInstance.close();
    }

    dismiss() {
        this.modalInstance.dismiss();
    }
}

InvoicesPaymentEditModalCtrl.$inject = [
    'invoice',
    'payment',
    'Invoice',
    'SweetAlert',
    'Error',
    '$uibModalInstance',
    'PaymentsService'
];

/**
 * @ngdoc object
 * @name billing.invoices:InvoicesPaymentEditModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesPaymentEditModalCtrl', InvoicesPaymentEditModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/payments/edit-modal-controller.js